









































































import Vue, { PropOptions } from 'vue';
import Tooltip from '~/components/Tooltip.vue';
import Stepper from '~/components/Stepper.vue';

type PricingColumnProps = Blok & {
  planName: string;
  planIcon: BlokFieldAsset;
  monthPrice: string;
  alternativePriceText: string;
  ribbonText: string;
  pricingOptions: string;
  showScreenInput: boolean;
  annualPrice: string;
  pricingInfo: string;
  alternativePricingInfo: string;
  description: string;
  cta: BlokFieldLink[];
  alternativeCta: BlokFieldLink[];
  properties: Blok[];
  scratchFirstProperty: boolean;
};

export default Vue.extend({
  components: {
    'an-stepper': Stepper,
    'an-tooltip': Tooltip,
  },
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<PricingColumnProps>,
    interval: {
      type: String,
      required: true,
    } as PropOptions<'annual' | 'month'>,
    showStepper: {
      type: Boolean,
    },
  },
  data: () => ({
    alternativePriceText: '',
    showAlternativeCTA: false,
    numberOfScreens: '5',
    selectedScreens: null,
    screenOptions: Array(0),
  }),
  computed: {
    price(): string {
      const { interval } = this;
      const key = `${interval}Price`;
      if (this.selectedScreens) {
        return `${this.selectedScreens?.[key]}`;
      }
      // @ts-ignore
      return this.blok[key] || 0;
    },
    ctaBlok() {
      const { blok, interval } = this;
      const { planName } = blok;
      const cta = this.blok.cta[0];
      const { url } = cta;
      let queryParams = `plan=${planName.toLowerCase()}&interval=${interval}ly`;
      if (this.screenOptions.length > 0) {
        queryParams = `${queryParams}&screen_qty=${this.numberOfScreens}`;
      }
      return {
        ...cta,
        url: {
          url: `${
            // @ts-ignore
            url.url
          }?${queryParams}`,
        },
      };
    },
    isFreePlan(): boolean {
      return this.blok.planName === 'Free';
    },
  },
  mounted() {
    (this as any).init();
  },
  methods: {
    gtmTrackClickPlan(planName: string): void {
      this.$gtm.push({
        event: 'pricing_page::pro_plan_button.gtm.clicked',
        event_category: 'Pricing',
        event_action: planName,
        value: this.numberOfScreens,
      });
      this.$tracking.trackEvent('pricing_page::pro_plan_button.clicked', {
        plan_name: this.blok.planName,
        interval: this.interval,
        screen_tier: this.numberOfScreens,
        value: this.numberOfScreens,
      });
    },
    init(): void {
      this.alternativePriceText = this.blok.alternativePriceText;
      (this as any).getScreenOptions().forEach((element: any) => {
        return this.screenOptions.push(element);
      });
    },
    getScreenOptions() {
      const { pricingOptions }: any = this.blok;
      if (pricingOptions) {
        const nameIndex = pricingOptions.thead.findIndex(
          (option: any) => option?.value === 'name'
        );
        const valueIndex = pricingOptions.thead.findIndex(
          (option: any) => option?.value === 'maxScreens'
        );
        const monthPriceIndex = pricingOptions.thead.findIndex(
          (option: any) => option?.value === 'monthPrice'
        );
        const annualPriceIndex = pricingOptions.thead.findIndex(
          (option: any) => option?.value === 'annualPrice'
        );
        const options =
          valueIndex || nameIndex
            ? pricingOptions.tbody.map((row: any) => {
                return {
                  value: row.body[valueIndex].value,
                  label: row.body[nameIndex].value,
                  monthPrice: row.body[monthPriceIndex].value,
                  annualPrice: row.body[annualPriceIndex].value,
                };
              })
            : [];
        if (options.length > 0) {
          options.push({
            value: 'talk',
            label: `${Number(options[options.length - 1].label) + 1}+`,
            monthPrice: "Let's talk",
            annualPrice: "Let's talk",
          });
        }
        return options;
      } else {
        return [];
      }
    },
    selectScreens(option: any): void {
      if (option.value === 'talk') {
        this.$tracking.trackEvent('pricing_page::custom_plan_button.clicked', {
          plan_name: this.blok.planName,
          interval: this.interval,
          screen_tier: '+31',
          value: '+31',
          event_label: option.value
        });
        this.selectedScreens = null;
        this.numberOfScreens = '5';
        this.alternativePriceText = option[`${this.interval}Price`];
        this.showAlternativeCTA = this.blok.alternativeCta.length > 0;
      } else {
        this.selectedScreens = option;
        this.numberOfScreens = option.value;
        this.alternativePriceText = this.blok.alternativePriceText;
        this.showAlternativeCTA = false;
        this.$tracking.trackEvent('pricing_page::select_tier_button.clicked', {
          plan_name: this.blok.planName,
          interval: this.interval,
          screen_tier: option.value,
          value: option.value,
          event_label: option.value
        });
      }
    },
  },
});
